const debug = process.env.NODE_ENV !== 'production' || /^public\.pushstart/.test(window.location.host);

const { version } = require('../../package.json');

console.log('PAGE VERSION', version);

export default {
    version,

    ga: {
        enabled: !debug,
        code: 'UA-64061972-18',
    },

    sentry: {
        enabled: !debug,
        dsn: 'https://f1292a5c75f54fb6a7ddc504531109b9@sentry.io/1309307',
    },
}


// WEBPACK FOOTER //
// ./src/utils/config.js